import React, { useEffect } from 'react';
import '../css/remixicon/remixicon.css'; 
import logo1 from '../img/logo/logo-1.png';
import logo2 from '../img/logo/logo-2.png';
import logo3 from '../img/logo/logo-3.png';
import logo4 from '../img/logo/logo-4.png';
import logo5 from '../img/logo/logo-5.png';
import logo6 from '../img/logo/logo-6.png';
import logo7 from '../img/logo/logo-7.png';
import logo8 from '../img/logo/logo-8.png';
import about1 from '../img/main-about-1.png';
import about2 from '../img/main-about-2.png';
import about3 from '../img/main-about-3.png';
import cert1 from '../img/cert-1.png';
import cert2 from '../img/cert-2.png';
import cert3 from '../img/cert-3.png';
import cert4 from '../img/cert-4.png';
import cert5 from '../img/cert-5.png';
import cert6 from '../img/cert-6.png';
import cert7 from '../img/cert-7.png';
import cert8 from '../img/cert-8.png';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const About = () => {
    useEffect(() => {
        const loadKakaoMap = () => {
            window.kakao.maps.load(() => {
                const mapContainer = document.getElementById('map');
                const mapOption = {
                    center: new window.kakao.maps.LatLng(35.2419, 128.6819), 
                    level: 3
                };
    
                const map = new window.kakao.maps.Map(mapContainer, mapOption);
                const geocoder = new window.kakao.maps.services.Geocoder();
    
                geocoder.addressSearch('경남 창원시 창원대로 18번길 46', (result, status) => {
                    if (status === window.kakao.maps.services.Status.OK) {
                        const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                        const marker = new window.kakao.maps.Marker({
                            map: map,
                            position: coords
                        });
    
                        const infowindow = new window.kakao.maps.InfoWindow({
                            content: '<div style="padding:5px;">위즈팩토리 본사</div>' 
                        });
                        
                        infowindow.open(map, marker);
                        map.setCenter(coords);
                    }
                });
            });
        };
    
        const script = document.createElement('script');
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_MAP_KEY}&libraries=services&autoload=false`;
        script.async = true;
        
        script.onload = loadKakaoMap;
        document.head.appendChild(script);
    
        return () => {
            document.head.removeChild(script); 
        };
    }, []);

    return(
        <div className="flex-1">
            <section className="page_title about">
                <div className="page_title_bg about"></div>
                <div className="page_title_text">
                    <h2>WIZ <span style={{ fontWeight: '300' }}>FACTORY</span></h2>
                        <p>클라우드 서비스 기반의 크로스 플랫폼 시작하기</p>
                </div>
            </section>
            <section className="about-intro">
                <div className="area">
                    <div className="main-title">
                        <h3>고객과 함께 성장하는 디지털 성장 파트너</h3>
                        <p>위즈팩토리의 스마트팩토리 솔루션은 제조 공정 전반에 걸쳐 데이터를 수집하고 분석하여 제조 기업이 보다 효율적으로 생산을 관리할 수 있도록 지원합니다.</p>
                    </div>
                    <ul className="about-img-3">
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    <div className="main-about-list">
                        <div className="list-item">
                            <img src={about1} alt="" className=""/>
                            <h3>사물인터넷</h3>
                            <p>제조 장비, 센서, 기계 등이 네트워크를 통해 상호 연결되어 실시간 데이터를 수집</p>
                        </div>
                        <div className="list-item">
                            <img src={about2} alt="" className=""/>
                            <h3>빅데이터 수집 및 분석</h3>
                            <p>수집된 대량의 데이터를 분석하여 의사결정 과정을 개선하고, 예측 유지보수, 수요 예측, 품질 관리 등을 수행</p>
                        </div>
                        <div className="list-item">
                            <img src={about3} alt=""className=""/>
                            <h3>인공지능</h3>
                            <p>머신 러닝 알고리즘을 통한 지속적인 학습으로 예측 분석, 고장 예측, 자동 결함 감지 등에 활용</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-history light">
                <div className="area">
                    <div className="main-title">
                        <h3>회사연혁</h3>
                        <p>저희와의 파트너십은 단순한 제품 공급 관계를 넘어, 혁신을 통한 시장 변화를 선도하고 새로운 비즈니스 기회를 창출 하는 데 중점을 둡니다. <br/>고객과 도전과 목표를 공유하며, 함께 성장해 나가고자 합니다.</p>
                    </div>
                    <div className="main-cont">
                        <div className="history-list">
                            <div className="history-year">
                                <h3>2024</h3>
                                <h3>2023</h3>
                                <h3>2022</h3>
                            </div>
                            <div className="history-item-wrap">
                                <ul className="history-item">
                                    <li>◦ LG CNS 협력업체 등록</li>
                                    <li>◦ LG전자 전사적 시스템 GLAS 수주 및 개발</li>
                                    <li>◦ 품질 결산 관리 시스템 특허 등록</li>
                                    <li>◦ 제조 생산 업무 협업 시스템 특허 출원</li>
                                    <li>◦ 제11회 대한민국 지식경영대상 시스템 소프트웨어 부문 대상</li>
                                    <li>◦ 머니투데이 2024 대한민국 굿컴퍼니대상의 'Good(굿) 스타트업 대상' 수상</li>
                                </ul>
                                <ul className="history-item">
                                    <li>◦ 벤처기업 등록</li>
                                    <li>◦ LG전자, LG이노텍, 자화전자 시스템 유지보수 계약 체결</li>
                                    <li>◦ 스마트 팩토리 플랫폼 공정관리 시스템 특허 등룩</li>
                                </ul>
                                <ul className="history-item">
                                    <li>◦ 위즈팩토리 설립</li>
                                    <li>◦ 서브원 협력업체 등록</li>
                                    <li>◦ LG전자 에어솔루션사업부 시스템 개발 수주 및 관련 하드웨어 납품</li>
                                    <li>◦ LG CNS 자회사 비즈테크 협력업체 등록</li>
                                </ul>
                            </div>
                        </div>
                    </div> 
                </div>
            </section>
            <section className="about-partner">
                <div className="area">
                    <div className="main-title">
                        <h3>파트너 & 고객사</h3>
                        <p>위즈팩토리는 다양한 산업군에서 신뢰할 수 있는 고객사와 협력하여 지속적인 성장을 이루어가며, 각 분야에서 두각을 나타내는 고객사와의 협업을 통해 혁신적인 솔루션을 제공하며, 서로의 성장을 도모하고 있습니다. 또한, 뛰어난 역량을 갖춘 파트너사들과의 전략적 제휴를 통해 보다 폭넓은 서비스를 제공하고 있습니다.</p>
                    </div>
                    <div className="main-cont">
                        <div className="about-partner-list">
                            <div className="partner-item"><img src={logo1} alt="logo1"/></div>
                            <div className="partner-item"><img src={logo2} alt="logo2"/></div>
                            <div className="partner-item"><img src={logo3} alt="logo3"/></div>
                            <div className="partner-item"><img src={logo4} alt="logo4"/></div>
                            <div className="partner-item"><img src={logo5} alt="logo5"/></div>
                            <div className="partner-item"><img src={logo6} alt="logo6"/></div>
                            <div className="partner-item"><img src={logo7} alt="logo7"/></div>
                            <div className="partner-item"><img src={logo8} alt="logo8"/></div>
                        </div>
                    </div> 
                </div>
            </section>
            <section className="about-cert light">
                <div className="area">
                    <div className="main-title">
                        <h3>인증 및 수상</h3>
                        <p>지속적인 혁신과 품질 개선을 통해 다양한 인증, 특허, 그리고 수상 경력을 자랑합니다. 이러한 성과는 고객 여러분께 최상의 가치를 제공하고자 하는 저희의 열정을 반영합니다.</p>
                    </div>
                    <div className="main-cont">
                        <div className="about-cert-list">
                            <div className="cert-item"><img src={cert1} alt="cert1"/></div>
                            <div className="cert-item"><img src={cert2} alt="cert2"/></div>
                            <div className="cert-item"><img src={cert3} alt="cert3"/></div>
                            <div className="cert-item"><img src={cert4} alt="cert4"/></div>
                            <div className="cert-item"><img src={cert5} alt="cert5"/></div>
                            <div className="cert-item"><img src={cert6} alt="cert6"/></div>
                            <div className="cert-item"><img src={cert7} alt="cert7"/></div>
                            <div className="cert-item"><img src={cert8} alt="cert8"/></div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-info">
                <div className="area flex">
                    <div className="half-title">
                        <h3>위즈팩토리 <br className="m-br"/>기업정보</h3>
                    </div>
                    <div className="half-cont">
                        <div className="info-table">
                            <dl>
                                <dt><p className="tbl-txt">회사명</p></dt>
                                <dd><p className="tbl-txt">주식회사 위즈팩토리</p></dd>
                            </dl>
                            <dl>
                                <dt><p className="tbl-txt">대표이사</p></dt>
                                <dd><p className="tbl-txt">배흥열</p></dd>
                            </dl>
                            <dl>
                                <dt><p className="tbl-txt">설립일</p></dt>
                                <dd><p className="tbl-txt">2022년 5월 11일</p></dd>
                            </dl>
                            <dl>
                                <dt><p className="tbl-txt">본사주소</p></dt>
                                <dd><p className="tbl-txt">경남 창원시 의창구 창원대로18번길 46, 경남창원과학기술진흥원 1114호</p></dd>
                            </dl>
                            <dl>
                                <dt><p className="tbl-txt">대표전화</p></dt>
                                <dd><p className="tbl-txt">055-715-7737</p></dd>
                            </dl>
                            <dl>
                                <dt><p className="tbl-txt">팩스</p></dt>
                                <dd><p className="tbl-txt">055-715-7738</p></dd>
                            </dl>
                            <dl>
                                <dt><p className="tbl-txt">이메일</p></dt>
                                <dd><p className="tbl-txt">wiz_biz@wiz-factory.com</p></dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-contact">
                <div id="map" style={{ 
                    width: '100%', 
                    height: '500px',
                    position: 'relative',
                    overflow: 'hidden'
                }}></div>
                <div className="contact_box"></div>
            </section>
        </div>
    );
};

export default About;